import React, { useState } from 'react';
import { committedBreakdown, committedTotal, totalBalance, fmtAed } from './walletFigures';
import './walletCommitted.css';

// Secondary, expandable detail that sits UNDER an available-balance headline.
// Renders nothing when nothing is committed (available === total), so a client
// with a clean wallet never sees an empty disclosure.
//
// Deliberately says the money is "set aside" rather than "spent": these are
// gross commitments (pending-booking reservations and requested payouts), not
// ledger debits.
//
// Due price adjustments used to be listed here too, under the note "It stays
// yours — it just isn't spendable until those are approved or cancelled". That
// sentence is true of a reservation and of a pending withdrawal, and FALSE of a
// debt: an adjustment is not money staying yours, it is money you owe, and it
// may be settled by card or ride on an invoice without ever touching the
// wallet. It now has its own "Amount owed" figure (walletFigures.amountOwed),
// so every row here genuinely does stay the client's.
export default function WalletCommitted({ wallet, className = '' }) {
    const [open, setOpen] = useState(false);
    const rows = committedBreakdown(wallet);
    if (rows.length === 0) return null;
    const total = committedTotal(wallet);

    return (
        <div className={`cwc ${className}`}>
            <button
                type="button"
                className="cwc__toggle"
                onClick={(e) => { e.stopPropagation(); e.preventDefault(); setOpen((v) => !v); }}
                aria-expanded={open}
            >
                {fmtAed(total)} set aside
                <span className="cwc__chev" aria-hidden="true">{open ? '▾' : '▸'}</span>
            </button>
            {open && (
                <div className="cwc__rows">
                    <div className="cwc__row cwc__row--total">
                        <span>Wallet total</span>
                        <strong>{fmtAed(totalBalance(wallet))}</strong>
                    </div>
                    {rows.map((r) => (
                        <div className="cwc__row" key={r.label}>
                            <span>
                                {r.label}
                                {r.count > 0 ? ` · ${r.count}` : ''}
                            </span>
                            <strong>−{fmtAed(r.amount)}</strong>
                        </div>
                    ))}
                    <div className="cwc__note">
                        Set aside for things already in progress. It stays yours — it just isn’t
                        spendable until those are approved or cancelled.
                    </div>
                </div>
            )}
        </div>
    );
}
